import React from 'react';
import "./SearchBar.css"
class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.handleFilterTextChange = this.handleFilterTextChange.bind(this);
    }

    handleFilterTextChange(e) {
        this.props.onFilterTextChange(e.target.value.toLowerCase());
    }
    onFormSubmit = e => {
        e.preventDefault();
        console.log("do the thing");
        // send to server
    };

    render() {
        return (
            <div className='search'>
                <form onSubmit={this.onFormSubmit}>
                    <input
                        type="text"
                        className='searchTerm'
                        placeholder="Search..."
                        value={this.props.filterText}
                        onChange={this.handleFilterTextChange}
                    />
                </form>
            </div>
        );
    }
}

export default SearchBar;
